import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { useLocation, useNavigate } from "react-router-dom";
import { Moon, Phone, Sun } from "@phosphor-icons/react";
import { useTheme } from "../../../theme";
import authBrandIcon from "../../../assets/design/HallTicket logo/app-icon/square-dark/hallticket-icon-256-dark.png";
import "./SignIn.css";

interface SignInLocationState {
  postAuthRedirect?: string;
}

export function SignIn() {
  const [mobile, setMobile] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { mode, toggleTheme } = useTheme();
  const postAuthRedirect = (location.state as SignInLocationState | null)?.postAuthRedirect;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    setSubmitted(true);
    setError(null);

    const trimmed = mobile.trim();
    if (!trimmed) {
      setError("Please enter your mobile number.");
      return;
    }
    if (!/^\d{10}$/.test(trimmed)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    navigate("/otp", { state: { mobile: trimmed, postAuthRedirect } });
  };

  return (
    <div className="auth-screen">
      <button type="button" className="theme-toggle" onClick={toggleTheme}>
        {mode === "dark" ? <Sun size={15} weight="bold" /> : <Moon size={15} weight="bold" />}
      </button>
      <div className="auth-card">
        <div className="brand">
          <div className="brand-icon"><img src={authBrandIcon} alt="HallTicket" className="brand-icon-img" /></div>
          <div className="brand-name">
            Hall<span>Ticket</span>
          </div>
        </div>
        <h2 className="auth-title">Welcome</h2>
        <p className="auth-sub">Sign in or create your account with your mobile number.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="mobile" className="field-label">
            Mobile Number
          </label>
          <div className="phone-row">
            <div className="country-code">
              <Phone size={14} weight="fill" />
              +91
            </div>
            <InputText
              id="mobile"
              type="tel"
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              placeholder="9876543210"
              className="inp"
              maxLength={10}
              aria-label="Mobile number"
              aria-invalid={submitted && !!error}
            />
          </div>
          <Button type="submit" label="Continue" className="btn btn-primary" />
          {error && <Message severity="error" text={error} className="auth-message" />}
        </form>
      </div>
    </div>
  );
}
